<script setup lang="ts"></script>

<template>
  <NuxtLayout :force-default-top-nav="true">
    <CommonNotFound class="is-error-404" />
  </NuxtLayout>
</template>
